export function toPascalCase(originalString) {
  if (originalString == null) return "";
  if (originalString.length == 0) {
    return originalString;
  } else if (originalString.includes("_")) {
    return originalString
      .replace(/_/g, " ")
      .split(" ")
      .map((word, index) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  } else {
    return (
      originalString.charAt(0).toUpperCase() +
      originalString.slice(1).toLowerCase()
    );
  }
}

export function capitalizeWords(str) {
  return str.replace(/\b\w/g, (firstChar) => firstChar.toUpperCase());
}

export const toUpperCase = (str) => str.toUpperCase();


export const toTitleCase = (str, separator = "_") => {
  if (!str) return "";
  return str
    .split(separator)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const shortFormatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
};


export const getCurrencySymbolByCode = (currencies, code) => {
  console.log("kmkmkm", currencies, code);

  const currency = currencies.find(
    (curr) => curr.code?.toUpperCase() === code?.toUpperCase(),
  );
  console.log("kmkmkm", currency);
  return currency?.symbol || null;
};

/**
 * Converts pricing period strings into display-friendly format
 * @param {string} period - The pricing period (per_month, per_quarter, per_year, one_time)
 * @returns {string} Formatted pricing period (e.g. "/Month", "/Quarterly", "/Year", "One Time")
 */
export function formatPricingPeriod(period) {
  const periodMap = {
    per_month: "/Month",
    per_quarter: "/Quarterly",
    per_year: "/Year",
    one_time: "One Time",
  };

  // Return the mapped value or the original string if not found
  return periodMap[period.toLowerCase()] || period;
}

// utils/agencyUtils.js

export const determineAgencyType = (agencyData) => {
  // Handle both string and array formats for regions
  let regions = agencyData?.regions || [];

  // Convert string to array if needed
  if (typeof regions === "string") {
    regions = [regions];
  }

  // Check if it's a marketing agency
  const isMarketing = regions.some((region) =>
    region.toLowerCase().includes("marketing"),
  );

  if (isMarketing) {
    // Extract regions from marketing agency regions
    const marketingRegions = extractMarketingRegions(regions);

    return {
      agencyType: "marketing",
      regions: marketingRegions,
      isAllRegions:
        marketingRegions.includes("*") || marketingRegions.length === 0,
    };
  }

  // It's a builder agency
  return {
    agencyType: "builder",
    regions: regions,
    isAllRegions: false,
  };
};

// export const extractMarketingRegions = (regions) => {
//   let extractedRegions = [];

//   regions.forEach(region => {
//     // Check if it's "All-Marketing"
//     if (region.toLowerCase().includes('all-marketing')) {
//       extractedRegions.push('all');
//       return;
//     }

//     // Extract regions from names like "delhi-punjab-up-marketing"
//     const multiRegionPattern = /([a-z]+(?:-[a-z]+)*)-marketing$/i;
//     const regionMatch = region.match(multiRegionPattern);

//     if (regionMatch) {
//       const regionsPart = regionMatch[1];
//       extractedRegions = [...extractedRegions, ...regionsPart.split('-')];
//     }
//   });

//   // Remove duplicates and convert to lowercase
//   return [...new Set(extractedRegions.map(r => r.toLowerCase()))];
// };

// export const extractMarketingRegions = (regions) => {
//   let extractedRegions = [];

//   regions.forEach(region => {
//     const regionLower = region.toLowerCase();

//     // Check if it's "All-Marketing" or "Marketing-All" etc.
//     if (regionLower.includes('all') && regionLower.includes('marketing')) {
//       extractedRegions.push('all');
//       return;
//     }

//     // Remove "marketing" from the string and split by hyphens
//     const regionsWithoutMarketing = regionLower
//       .replace(/marketing/gi, '') // remove all occurrences of marketing
//       .split('-') // split by hyphens
//       .filter(part => part.trim() !== ''); // remove empty parts

//     extractedRegions = [...extractedRegions, ...regionsWithoutMarketing];
//   });

//   // Remove duplicates
//   return [...new Set(extractedRegions)];
// };

export const extractMarketingRegions = (regions) => {
  let extractedRegions = [];

  regions.forEach((region) => {
    // Check if it's "*-Marketing" (case-sensitive match)
    if (region === "*-Marketing") {
      extractedRegions.push("*");
      return;
    }

    // Split by hyphens and filter out "marketing" (case-insensitive)
    const parts = region.split("-");
    const nonMarketingParts = parts.filter(
      (part) => !part.toLowerCase().includes("marketing"),
    );

    // Add the non-marketing parts to extracted regions
    extractedRegions = [...extractedRegions, ...nonMarketingParts];
  });

  // Remove duplicates while preserving original case
  const uniqueRegions = [];
  extractedRegions.forEach((region) => {
    if (!uniqueRegions.includes(region)) {
      uniqueRegions.push(region);
    }
  });

  return uniqueRegions;
};

/**
 * Filter out shortlisted properties from the main list
 * @param {Array} allProperties - Main array of all properties
 * @param {Array} shortlistedProperties - Array of shortlisted properties
 * @returns {Array} - Array of properties not in the shortlist
 */
// export const getNonShortlistedProperties = (
//   allProperties,
//   shortlistedProperties,
//   // SetLoading=void=>()
// ) => {
//   if (!Array.isArray(allProperties) || !Array.isArray(shortlistedProperties)) {
//     return [];
//   }

//   // Create a Set of shortlisted property IDs for O(1) lookup
//   const shortlistedIds = new Set(
//     shortlistedProperties.map((property) => property.id)
//   );
//   // Filter out properties whose IDs are in the shortlisted set
//   const temp = allProperties.filter(
//     (property) => !shortlistedIds.has(property._id)
//   );

//   return temp;
// };

export const getNonShortlistedProperties = async (
  allProperties,
  shortlistedProperties,
  setIsDataLoaded,
) => {
  if (!Array.isArray(allProperties) || !Array.isArray(shortlistedProperties)) {
    return [];
  }

  // Set loading state if provided
  if (setIsDataLoaded && typeof setIsDataLoaded === "function") {
    setIsDataLoaded(true);
  }

  try {
    // Create a Set of shortlisted property IDs for O(1) lookup
    const shortlistedIds = new Set(
      shortlistedProperties.map((property) => property.id || property._id),
    );

    // Filter out properties whose IDs are in the shortlisted set
    const nonShortlisted = allProperties.filter(
      (property) => !shortlistedIds.has(property._id),
    );
    console.log("nonShortlisted", nonShortlisted);

    return nonShortlisted;
  } catch (error) {
    console.error("Error in getNonShortlistedProperties:", error);
    return [];
  } finally {
    // Always set loading to false when done
    if (setIsDataLoaded && typeof setIsDataLoaded === "function") {
      setIsDataLoaded(false);
    }
  }
};

// Validate and clean search input
export const validateAndCleanSearchInput = (input) => {
  // If input is completely empty, it's valid (empty search)
  if (input === "") {
    return {
      cleanedValue: "",
      isValid: true,
      message: "",
    };
  }

  // Step 1: Check for special characters and numbers
  const specialCharPattern = /[0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/;
  if (specialCharPattern.test(input)) {
    return {
      cleanedValue: input.replace(
        /[0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/g,
        "",
      ),
      isValid: false,
      message: "Numbers and special characters are not allowed",
    };
  }

  // Step 2: Check for spaces at start or end
  const trimmedInput = input.trim();
  if (input !== trimmedInput) {
    return {
      cleanedValue: trimmedInput,
      isValid: false,
      message: "Spaces at the beginning or end are not allowed",
    };
  }

  // Step 3: Check if input contains only spaces (after trimming)
  if (trimmedInput === "") {
    return {
      cleanedValue: "",
      isValid: false,
      message: "Search term cannot contain only spaces",
    };
  }

  // Step 4: Check minimum length (at least 2 characters)
  if (trimmedInput.length < 2) {
    return {
      cleanedValue: trimmedInput,
      isValid: false,
      message: "Search term must be at least 2 characters long",
    };
  }

  // Step 5: Remove multiple spaces between words
  const finalValue = trimmedInput.replace(/\s+/g, " ");

  // Step 6: Check if contains any invalid characters (should only contain letters, spaces, hyphens, apostrophes)
  const validPattern = /^[a-zA-Z\s\-']+$/;
  if (!validPattern.test(finalValue)) {
    return {
      cleanedValue: finalValue.replace(/[^a-zA-Z\s\-']/g, ""),
      isValid: false,
      message: "Only letters, spaces, hyphens, and apostrophes are allowed",
    };
  }

  // All validations passed
  return {
    cleanedValue: finalValue,
    isValid: true,
    message: "",
  };
};

// Validate and clean mobile number or email input
export const validateAndCleanContactInput = (input) => {
  // Trim the input first
  const trimmedInput = input.trim();

  // If input is empty
  if (trimmedInput === "") {
    return {
      cleanedValue: "",
      isValid: false,
      message: "Please enter a valid email or mobile number",
      type: "invalid",
    };
  }

  // Check if it's an email
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const isEmail = emailPattern.test(trimmedInput);

  // Check if it's a mobile number
  const mobilePattern = /^[\d\s\+\-\(\)]{10,15}$/; // Allows digits, spaces, +, -, (, )
  const cleanMobileNumber = trimmedInput.replace(/[^\d\+]/g, ""); // Remove non-digit and non-plus chars

  // For mobile validation, we check the cleaned version
  const isMobile =
    mobilePattern.test(trimmedInput) &&
    cleanMobileNumber.replace(/[^\d]/g, "").length >= 10; // At least 10 digits

  if (isEmail) {
    // Email validation and cleaning
    const email = trimmedInput.toLowerCase(); // Normalize to lowercase

    // Additional email validations
    if (email.length > 254) {
      return {
        cleanedValue: email,
        isValid: false,
        message: "Email address is too long (max 254 characters)",
        type: "email",
      };
    }

    // Check for consecutive dots
    if (/\.{2,}/.test(email)) {
      return {
        cleanedValue: email.replace(/\.{2,}/g, "."),
        isValid: false,
        message: "Email cannot have consecutive dots",
        type: "email",
      };
    }

    // Check for valid domain
    const domainPart = email.split("@")[1];
    if (domainPart && /^\./.test(domainPart)) {
      return {
        cleanedValue: email,
        isValid: false,
        message: "Email domain cannot start with a dot",
        type: "email",
      };
    }

    return {
      cleanedValue: email,
      isValid: true,
      message: "",
      type: "email",
    };
  } else if (isMobile) {
    // Mobile number validation and cleaning

    // Remove all non-digit characters except leading +
    let cleanedMobile = trimmedInput.replace(/[^\d\+]/g, "");

    // If starts with +, keep it, otherwise ensure it starts with digit
    if (!cleanedMobile.startsWith("+")) {
      cleanedMobile = cleanedMobile.replace(/\D/g, ""); // Remove all non-digits
    }

    // Ensure minimum length
    const digitCount = cleanedMobile.replace(/[^\d]/g, "").length;
    if (digitCount < 10) {
      return {
        cleanedValue: cleanedMobile,
        isValid: false,
        message: "Mobile number must have at least 10 digits",
        type: "mobile",
      };
    }

    // Ensure maximum length
    if (digitCount > 15) {
      return {
        cleanedValue: cleanedMobile.substring(0, 15),
        isValid: false,
        message: "Mobile number is too long (max 15 digits)",
        type: "mobile",
      };
    }

    // Format the mobile number for display (optional)
    const formattedMobile = formatMobileNumber(cleanedMobile);

    return {
      cleanedValue: formattedMobile || cleanedMobile,
      isValid: true,
      message: "",
      type: "mobile",
    };
  } else {
    // Neither valid email nor mobile

    // Check if it might be an email missing @ or domain
    if (trimmedInput.includes("@")) {
      if (!trimmedInput.includes(".")) {
        return {
          cleanedValue: trimmedInput,
          isValid: false,
          message: "Email must contain a domain (e.g., example.com)",
          type: "email",
        };
      }
      return {
        cleanedValue: trimmedInput.toLowerCase(),
        isValid: false,
        message: "Please enter a valid email address",
        type: "email",
      };
    }

    // Check if it might be a mobile number with wrong format
    const digitCount = trimmedInput.replace(/\D/g, "").length;
    if (digitCount > 0) {
      if (digitCount < 10) {
        return {
          cleanedValue: trimmedInput.replace(/\D/g, ""),
          isValid: false,
          message: "Mobile number must have at least 10 digits",
          type: "mobile",
        };
      } else {
        return {
          cleanedValue: trimmedInput.replace(/[^\d\+]/g, ""),
          isValid: false,
          message: "Please enter a valid mobile number",
          type: "mobile",
        };
      }
    }

    // General invalid input
    return {
      cleanedValue: trimmedInput,
      isValid: false,
      message: "Please enter a valid email or mobile number (10+ digits)",
      type: "invalid",
    };
  }
};

// Helper function to format mobile number (optional)
const formatMobileNumber = (mobile) => {
  // Remove all non-digit characters
  const digits = mobile.replace(/\D/g, "");

  if (digits.length === 10) {
    // Format as (XXX) XXX-XXXX for US numbers
    return `(${digits.substring(0, 3)}) ${digits.substring(
      3,
      6,
    )}-${digits.substring(6)}`;
  } else if (digits.length === 11 && digits.startsWith("1")) {
    // Format as +1 (XXX) XXX-XXXX for US numbers with country code
    return `+1 (${digits.substring(1, 4)}) ${digits.substring(
      4,
      7,
    )}-${digits.substring(7)}`;
  } else if (digits.length > 10) {
    // For international numbers, format with +
    return `+${digits}`;
  }

  // Return as is if no specific format applies
  return mobile;
};

export const formatAddress = (...fields) =>
  fields.filter((v) => v && v.trim()).join(", ");
